const daysBetweenDate = (date1, date2) => {
  var date1_ms = date1.getTime();
  var date2_ms = date2.getTime();
  let difference_ms = Math.abs(date2_ms - date1_ms);
  return Math.floor(difference_ms / (1000 * 60 * 60 * 24));
};

export default daysBetweenDate;
